import { writable } from 'svelte/store';

/**
 * The data-selection search box.
 *
 * `DataSelectionFilters` owns the input and `DataSelection` renders the
 * filtered list; they are siblings with no shared ancestor passing props, so
 * the query travelled between them through `window.dataSelectionSearch` — a
 * store assigned onto the global object by whichever component mounted first.
 *
 * A module-level store does the same job with two differences that are both
 * improvements. It is typed, where the global was untyped and needed a
 * `Window` augmentation to exist at all. And it is always there: the reader
 * guarded on `window.dataSelectionSearch` being set, so a query typed before
 * the list had mounted was silently dropped.
 */
export const dataSelectionSearch = writable('');
